var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8874 6.00041C11.8874 9.0559 9.4104 11.5329 6.3549 11.5329C3.29941 11.5329 0.822444 9.0559 0.822444 6.00041C0.822444 2.94492 3.29941 0.467952 6.3549 0.467952C9.4104 0.467952 11.8874 2.94492 11.8874 6.00041Z",
    stroke: "#00FF00",
    strokeWidth: 0.737661
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.77344 5.95225L5.22898 7.40779C5.24312 7.42192 5.2623 7.42986 5.28229 7.42986C5.30228 7.42986 5.32146 7.42192 5.3356 7.40779L9.3059 3.4375",
    stroke: "#00FF00",
    strokeWidth: 0.603541
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/greentick.9b09b1d5e9d87095837a2de2ccd891d1.svg";
export { ForwardRef as ReactComponent };